export enum DATE_SELECTOR_MODE {
  DATE_RANGE = 'DATE_RANGE',
  MULTIPLE_DATES = 'MULTIPLE_DATES',
}